import React, { useState } from 'react';

const GiftCardList = ({ predefinedAmounts = [25, 50, 100, 200], onSelect }) => {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState('');

  const handlePredefinedSelect = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount('');
    if (onSelect) onSelect(amount);
  };

  const handleCustomChange = (e) => {
    const value = e.target.value;
    setCustomAmount(value);
    setSelectedAmount(null);
    if (onSelect && value !== '') {
      onSelect(parseFloat(value));
    }
  };

  return (
    <div className="gift-card-container">
      <h3>Select a Gift Card Amount</h3>
      <div className="gift-card-options">
        {predefinedAmounts.map((amount) => (
          <button
            key={amount}
            className={`gift-card-btn ${selectedAmount === amount ? 'selected' : ''}`}
            onClick={() => handlePredefinedSelect(amount)}
          >
            ₹{amount}
          </button>
        ))}
        <div className="custom-amount-input">
          <input
            type="number"
            placeholder="Custom amount"
            value={customAmount}
            onChange={handleCustomChange}
            min="1"
          />
        </div>
      </div>
    </div>
  );
};

export default GiftCardList;
